export default "/images/vendor/flag-icon-css/flags/1x1/vg.svg?76c17dc332a16129789a6a33f58627a3";